import {
  Statistics,
  StatisticsStatus,
} from "@app/core/statistics/domain/model/statistics";
import { Section } from "@app/core/match/domain/model/section";
import fakeSections from "../evolutionary-sections-v2.fake";

const statusMapper = {
  "In progress": StatisticsStatus.IN_PROGRESS,
  OK: StatisticsStatus.OK,
};

export class EvolutionaryMapper {

  private static orderApiResponse(response: any[]): any[] {
    const orderedResponse = response
      .map((group) => ({
        ...group,
        statistics: group.statistics
          .map((stat: any) => ({
            ...stat,
            stat: Array.isArray(stat.stat)
              ? stat.stat.sort((a: any, b: any) => a.value_orden - b.value_orden)
              : stat.stat,
          }))
        .sort((a: any, b: any) => a.orden - b.orden),
      }))
      .sort((a: any, b: any) => a.order - b.order);

    return orderedResponse
  }

  private static processChartGroup(data: any): Section[] | [] {
    let charts: Section[] = []
    for (const key in data) {
      const section = data[key];
      charts.push({
        section_id: section.id,
        section_title: section.title,
        section_short_title: section.title_short,
        section_info: section.description,
        linechart: section.type === 'line_chart' ? 
          {
            xlimit: section.x_axis_limit,
            ylimit: section.y_axis_limit,
            stat: section.stat
          } : undefined,
        barchart: section.type === 'stacked_chart' ? 
          {
            xlimit: section.x_axis_limit,
            ylimit: section.y_axis_limit,
            stat: section.stat
          } : undefined,
        stat_type: section.type === 'line_chart' ? 'linechart' : 'barchart'
      })
    }

    return charts
  }

  private static mapSections(response: any[]): Section[] {

    let sections: Section[] = [];
  
    for (const key in response) {
      const section = response[key];

      sections.push({
        section_id: section.id,
        section_title: section.title,
        stat_type: 'chartgroup',
        charts: this.processChartGroup(section.statistics)
      })

    }
    return sections

  }

  static deserialize(response: any): Statistics {

    if (response.all_stats.length === 0) {
      return new Statistics({
        status: statusMapper[response.status as keyof typeof statusMapper],
        totalMatches: 0,
        stats: [],
      });
    }

    let sections: Section[] = []
    const orderedResponse = this.orderApiResponse(response.all_stats);
    sections = this.mapSections(orderedResponse);
    console.log('sections', sections)
    const sections_v2 = response.sections_v2
    console.log('sections_v2', sections_v2)
    console.log('fakeSections', fakeSections)

    return new Statistics({
      status: statusMapper[response.status as keyof typeof statusMapper],
      stats: sections,
      stats_v2: sections_v2,
      totalMatches: response.total_matches,
    });
  }
}
